var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNotificationInfo = function SvgNotificationInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#428FEF",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M8 15.778A7.778 7.778 0 1 0 8 .222a7.778 7.778 0 0 0 0 15.556m0-1.334A6.444 6.444 0 1 1 8 1.556a6.444 6.444 0 0 1 0 12.888"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M8.667 10.844V8a.667.667 0 0 0-1.334 0v2.844a.667.667 0 1 0 1.334 0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 5.156,
    r: 1
  }))));
};
export default SvgNotificationInfo;